import styled from 'styled'

const SupportText = styled.div`
  font-size: 8px;
  align-self: flex-end;
  margin: ${props => props.theme.spaces.stack.xxs};
`
export default SupportText
